import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IAssetTracking } from '@model/assetTracking';
import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

interface IUseGpsAssetKeys {
  query?: string;
  sorting?: ITableSorting;
  filtersStatus?: string;
}

interface IParams {
  filters: {
    query?: string;
    status?: string;
  };
  sort?: { column: string; direction?: string };
}

export const gpsAssetsKey = (keys: IUseGpsAssetKeys): [string, string, string, ITableSorting | undefined] => [
  'gpsAssets',
  keys?.query || '',
  keys?.filtersStatus || '',
  keys?.sorting,
];

export const gpsAssetsFn = ({ queryKey }: QueryFunctionContext<ReturnType<typeof gpsAssetsKey>>) => {
  const params: IParams = { filters: { status: queryKey[2] } };

  if (queryKey[1]?.length > 2) {
    params.filters.query = queryKey[1];
  }

  if (queryKey[3]?.id) {
    const direction = queryKey[3].desc ? 'desc' : 'asc';

    params.sort = {
      column: queryKey[3].id,
      direction,
    };
  }

  return apiClient.get(`${APP_API_URL_V2}fsd/gps-assets`, { params });
};

const selectData = ({ data }: AxiosResponse<{ data: Array<IAssetTracking> }>) => {
  const assetsList = data?.data || [];

  const assetMapMarkers = assetsList?.filter((asset) => asset?.lastReport?.location);

  return {
    assetMapMarkers,
    list: assetsList,
  };
};

export const useGPSAssetsQuery = (keys: IUseGpsAssetKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: gpsAssetsKey(keys),
    queryFn: gpsAssetsFn,
    useErrorBoundary: true,
    select: selectData,
    refetchInterval: 10 * 60 * 1000,
    placeholderData: {
      data: {
        data: [],
      },
    },
  });
};
